import { h } from 'preact';

export default props => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M3.33398 8H12.6673" stroke-linecap="round" />
	</svg>
);